export default {
    name: "model-data-table-pagination",
    computed: {

        /**
         * 
         */
        paginationProps () {
            return {                
                disabled    : Boolean( !! this.loading ),
                length      : Number( this.pagination.length ),
                totalVisible: Number( this.totalVisible ),
            }
        },

        /**
         * 
         */
        selectProps () {
            return {
                disabled    : Boolean( !! this.loading ),
                items       : this.limits,
                loading     : this.loading,
                menuProps   : {
                    contentClass: "pagination",
                },
            }
        },
    },
    data () {
        return {
            limits      : [ 10, 15, 25, 50, 100 ],
            pagination  : {
                current : 1,
                from    : 1,
                length  : 1,
                limit   : 10,
                to      : 15,
                total   : 100,
            },
        }
    },
    mounted () {
        this.pagination = this.value
    },
    props: {

        /**
         * 
         */
        color: {
            type: String,
            default: "primary",
        },

        /**
         * 
         */
        loading: [ Boolean, String ],

        /**
         * 
         */
        resources: String,

        /**
         * 
         */
        totalVisible: {
            type: Number,
            default: 7,
        },

        /**
         * 
         */
        value: Object,
    },
    watch: {

        /**
         * 
         */
        pagination: {

            /**
             * 
             */
            handler () {
                this.$emit( 'input', this.pagination )
            },
            
            //
            deep: true,
        },

        /**
         * 
         */
        value () {
            this.pagination = this.value
        },
    }
}